import React from 'react';
import { authService, ForgotPasswordRequest } from '../services/auth';
import { useAuthForm } from '../hooks/useAuthForm';
import AuthPageLayout from '../components/ui/AuthPageLayout';
import EmailField from '../components/ui/EmailField';
import AlertMessage from '../components/ui/AlertMessage';
import SubmitButton from '../components/ui/SubmitButton';
import AuthLink from '../components/ui/AuthLink';

const ForgotPassword: React.FC = () => {
  const {
    formData,
    handleInputChange,
    isLoading,
    setIsLoading,
    error,
    setError,
    success,
    setSuccess,
  } = useAuthForm<ForgotPasswordRequest>({
    email: '',
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setSuccess('');

    try {
      await authService.forgotPassword(formData);
      setSuccess(
        "If an account with that email exists, we've sent you a password reset link. Please check your email."
      );
    } catch (err: any) {
      // Note: The backend always returns success to prevent email enumeration
      setSuccess(
        "If an account with that email exists, we've sent you a password reset link. Please check your email."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthPageLayout
      title="Reset your password"
      description="Enter your email address and we'll send you a link to reset your password."
    >
      <form className="space-y-6" onSubmit={handleSubmit}>
        <AlertMessage type="error" message={error} show={!!error} />
        <AlertMessage type="success" message={success} show={!!success} />

        <EmailField
          id="email"
          name="email"
          label="Email address"
          placeholder="Enter your email address"
          value={formData.email}
          onChange={handleInputChange}
          required
          autoComplete="email"
        />

        <SubmitButton isLoading={isLoading} disabled={success !== ''}>
          Send reset link
        </SubmitButton>

        <div className="text-center">
          <AuthLink to="/signin">← Back to sign in</AuthLink>
        </div>
      </form>
    </AuthPageLayout>
  );
};

export default ForgotPassword;
